import React from 'react';
import cx from 'classnames';
import { isAllPaperAddOnsCardType } from 'cards/constants/CardTypes';
import { useAppSelector } from 'reducers/index';
import { getUserContext } from 'selectors/user/userSelectors';
import { useIsPostAuthNav3MobileOrDesktop } from 'util/isPostAuthNav3Active';

import styles from './styles.module.less';

const CardListingWrapper = ({ activeCardEvent, children, isMobile, contentClassName }) => {
  const isPaperAddOns = isAllPaperAddOnsCardType(activeCardEvent);

  const userContext = useAppSelector(getUserContext);
  const isPostAuthNav3 = useIsPostAuthNav3MobileOrDesktop(userContext);

  if (isMobile && !isPaperAddOns) {
    return <div className={cx(styles.content, 'row', contentClassName)}>{children}</div>;
  }

  return (
    <div className={cx(styles.container, 'row', { [styles.postAuthNav3Shown]: isPostAuthNav3 })}>
      <div className={cx(styles.content, contentClassName)}>{children}</div>
    </div>
  );
};

export default CardListingWrapper;
